import moment from "moment-timezone";


export const utcToLocal = (utcString) => {
    return moment.utc(utcString).local().format("hh:mm a");
};

export const formatChatListDate = (utcString) => {
    if (!utcString) return '';

    const date = moment.utc(utcString).local();
    if (!date.isValid()) return '';

    const now = moment();
    const diffDays = now.clone().startOf('day').diff(date.clone().startOf('day'), 'days');

    if (diffDays <= 0) {
        // Today (or a clock-skew edge case putting it "in the future")
        return date.format('hh:mm a');
    }
    if (diffDays === 1) {
        return 'Yesterday';
    }
    if (diffDays < 7) {
        return date.format('dddd'); // e.g. "Monday"
    }

    const sameYear = date.year() === now.year();
    return date.format(sameYear ? 'D MMM' : 'D MMM YYYY');
};

const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000;

export const isOlderThanTwoWeeks = (dateString) => {
    if (!dateString) return false;
    const normalized = /Z$|[+-]\d{2}:\d{2}$/.test(dateString)
        ? dateString
        : `${dateString}Z`;
    const created = new Date(normalized);
    if (isNaN(created.getTime())) return false;
    return Date.now() - created.getTime() > TWO_WEEKS_MS;
};